import { createAsyncTypes } from '../utils';

export const ADVANCED_SEARCH_ALL_GENERAL = createAsyncTypes('ADVANCED_SEARCH_ALL_GENERAL');
export const ADVANCED_SEARCH_RESET = 'ADVANCED_SEARCH_RESET';
export const ADVANCED_SEARCH_FORM_FILTER_SET = 'ADVANCED_SEARCH_FORM_FILTER_SET';
export const ADVANCED_SEARCH_URL_PARAMS_UPDATE = 'ADVANCED_SEARCH_URL_PARAMS_UPDATE';
export const ADVANCED_SEARCH_ALERT = createAsyncTypes('ADVANCED_SEARCH_ALERT');
export const ADVANCED_SEARCH_RESULT_DOCKET_UPDATE = 'ADVANCED_SEARCH_RESULT_DOCKET_UPDATE';
export const ADVANCED_SEARCH_DOCUMENT_FETCH = createAsyncTypes('ADVANCED_SEARCH_DOCUMENT_FETCH');



// WEBPACK FOOTER //
// ./src/redux/actionTypes/advancedSearchActionTypes.js